<ng-container #container></ng-container>

@if (hasAddButton) {

	<div class="add-button">
		<lib-shared-button class="primary"
						   [disabled]="addButtonDisabled"
						   (click)="addListItem()">

			{{ getAddButtonText | translate }}

		</lib-shared-button>
	</div>

}